<section id="inspection-process-timeline" class="inspection-process-timeline" aria-labelledby="inspectionProcessTimelineTitle">
  <div class="site-container">
    <header class="inspection-process-timeline__header">
      <div>
        <p class="eyebrow">Inspection process</p>
        <h2 id="inspectionProcessTimelineTitle">From request to report, the inspection stays organized.</h2>
      </div>
      <p>
        GTX keeps each handoff documented so buyers, sellers, agents, and homeowners know what happened, what was
        observed, and what needs review after the visit.
      </p>
    </header>

    <div class="inspection-process-timeline__viewport">
      <ol class="inspection-process-timeline__steps" aria-label="GTX inspection process timeline">
        <li
          *ngFor="let step of processSteps; let i = index"
          class="inspection-process-timeline__step"
          [class.is-reversed]="i % 2 === 1"
          [style.--step-accent]="step.accent">
          <article class="inspection-process-timeline__copy">
            <span>{{ step.label }}</span>
            <h3>{{ step.title }}</h3>
            <p>{{ step.summary }}</p>
          </article>

          <div class="inspection-process-timeline__axis" aria-hidden="true">
            <span></span>
          </div>

          <div class="inspection-process-timeline__icon-shell">
            <span class="inspection-process-timeline__step-number">{{ i + 1 }}</span>
            <span class="inspection-process-timeline__icon" [ngSwitch]="step.icon" aria-hidden="true">
              <svg *ngSwitchCase="'calendar'" viewBox="0 0 24 24" focusable="false">
                <rect x="4" y="5" width="16" height="15" rx="2"></rect>
                <path d="M8 3v4M16 3v4M4 10h16M8 14h2M13 14h3M8 17h2"></path>
              </svg>
              <svg *ngSwitchCase="'access'" viewBox="0 0 24 24" focusable="false">
                <circle cx="8" cy="9" r="4"></circle>
                <path d="M11 12l8 8M16 17l2-2M18 19l2-2"></path>
              </svg>
              <svg *ngSwitchCase="'review'" viewBox="0 0 24 24" focusable="false">
                <path d="M4 11l8-7 8 7"></path>
                <path d="M6 10v10h12V10"></path>
                <path d="M9 15l2 2 4-5"></path>
              </svg>
              <svg *ngSwitchCase="'camera'" viewBox="0 0 24 24" focusable="false">
                <path d="M5 7h3l1.5-2h5L16 7h3a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2Z"></path>
                <circle cx="12" cy="13" r="3.5"></circle>
              </svg>
              <svg *ngSwitchCase="'report'" viewBox="0 0 24 24" focusable="false">
                <path d="M7 3h7l4 4v14H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"></path>
                <path d="M14 3v5h4M8 12h8M8 16h5M8 19h7"></path>
              </svg>
              <svg *ngSwitchDefault viewBox="0 0 24 24" focusable="false">
                <path d="M5 5h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-7l-5 4v-4H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z"></path>
                <path d="M8 9h8M8 13h5"></path>
              </svg>
            </span>
          </div>
        </li>
      </ol>
    </div>
  </div>
</section>
